import { render, staticRenderFns } from "./integrations.vue?vue&type=template&id=2d5eb9d0&scoped=true"
import script from "./integrations.vue?vue&type=script&lang=ts"
export * from "./integrations.vue?vue&type=script&lang=ts"
import style0 from "./integrations.vue?vue&type=style&index=0&id=2d5eb9d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5eb9d0",
  null
  
)

export default component.exports